import 'react-responsive-carousel/lib/styles/carousel.min.css'
import './App.css'

import { fetchSystem } from 'api/System/actions'
import { fetchUser } from 'api/User/actions'
import { Loader } from 'components'
import OfflineNotification from 'components/OfflineNotification'
import config from 'config'
import { ConnectedRouter } from 'connected-react-router'
import { PATHS } from 'constants.js'
import { Copyright } from 'Copyright'
import { DatePickerDialog } from 'DatePickerDialog'
import { ErrorBoundary } from 'ErrorBoundary'
import { GlobalStyles } from 'GlobalStyles'
import Home from 'Home'
import { selectLanguageBasedOnBrowserLocale } from 'locale'
import { Notifications } from 'Notifications'
import { SnackbarProvider } from 'notistack'
import PropTypes from 'prop-types'
import { RankingsBoxContainer } from 'rankings'
import React, { Component } from 'react'
import ReactGA from 'react-ga'
import { Provider } from 'react-redux'
import { Route, Switch } from 'react-router'
import { ReportBugDialog } from 'ReportBugDialog'
import { history } from 'store'
import theme from 'theme'

import MomentUtils from '@date-io/moment'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import { ThemeProvider } from '@mui/material/styles'

import { ErrorPage, Layout, NoAccess } from './layout'

const updateServiceWorkers = async () => {
  const registrationsArray = await navigator.serviceWorker.getRegistrations()
  if (!Array.isArray(registrationsArray)) {
    return
  }

  return Promise.all(registrationsArray.map(registrationItem => registrationItem.update()))
}

class App extends Component {
  constructor(...args) {
    super(...args)

    if (config.analyticsId && config.analyticsId !== 'none') {
      ReactGA.initialize(config.analyticsId)
      ReactGA.pageview(`${window.location.href}/`)
    }
  }

  state = {
    serviceWorkersChecked: false,
  }

  componentDidMount() {
    this.initialize()
  }

  async initialize() {
    const { dispatch } = this.props.store

    try {
      dispatch(fetchSystem())
      dispatch(fetchUser())

      await updateServiceWorkers()
    } catch (e) {
      // do nothing
    }

    // no need to worry if component is mounted or not - if it is unmounted it means that page is reloaded
    this.setState({ serviceWorkersChecked: true })
  }

  render() {
    if (!this.state.serviceWorkersChecked) {
      return <Loader />
    }

    return (
      <Provider store={this.props.store}>
        <ConnectedRouter history={history}>
          <ErrorBoundary>
            <LocalizationProvider dateAdapter={MomentUtils}>
              <ThemeProvider theme={theme}>
                <SnackbarProvider>
                  <Notifications />
                  <GlobalStyles />
                  <div className="container">
                    <Switch>
                      <Route path={PATHS.RANKINGS}>
                        <Layout>
                          <RankingsBoxContainer />
                          <Copyright />
                        </Layout>
                      </Route>
                      <Route path={PATHS.ERROR} component={ErrorPage} />
                      <Route path={PATHS.NO_ACCESS} component={NoAccess} />
                      <Route>
                        <Home />
                      </Route>
                    </Switch>
                  </div>
                  <DatePickerDialog />
                  <ReportBugDialog />
                  <OfflineNotification />
                </SnackbarProvider>
              </ThemeProvider>
            </LocalizationProvider>
          </ErrorBoundary>
        </ConnectedRouter>
      </Provider>
    )
  }
}

App.defaultProps = {
  language: localStorage.getItem('lang') || selectLanguageBasedOnBrowserLocale(),
}

App.propTypes = {
  language: PropTypes.string,
  pathname: PropTypes.string,
  store: PropTypes.shape({
    dispatch: PropTypes.func.isRequired,
  }).isRequired,
  userPrivileges: PropTypes.object.isRequired,
}

export default App
